import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import DOMPurify from 'dompurify';
import marked from 'marked';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useIntl, FormattedTime } from 'react-intl';

const styles = (theme) =>
	({
		root :
		{
			display    : 'flex',
			flexShrink : 0,
			// backgroundColor: '#a9daeb',
			boxShadow  : 'none',
			padding    : '0.5rem 0',
			wordWrap   : 'break-word',
			wordBreak  : 'break-all',
			alignItems : 'center',
			fontFamily : 'Twemoji Country Flags'
		},
		single :
		{
			marginTop    : theme.spacing(1),
			borderRadius : '10px 10px 10px 10px'
		},
		combinedBegin :
		{
			marginTop    : theme.spacing(1),
			borderRadius : '10px 10px 0px 0px'
		},

		combinedMiddle :
		{
			marginBottom : theme.spacing(0),
			borderRadius : '0px 0px 0px 0px'
		},
		combinedEnd :
		{
			marginBottom : theme.spacing(0),
			borderRadius : '0px 0px 10px 10px'
		},
		combinedTime :
		{
			width          : '75px',
			alignSelf      : 'center',
			fontSize       : '13px',
			color          : '#999999',
			dispay         : 'flex',
			display        : 'flex',
			justifyContent : 'center'
		},
		sent :
		{
			flexDirection : 'row-reverse',
			width         : '100%'
		},
		received :
		{
			width      : '100%',
			alignItems : 'flex-end'		},
		name : {

		},
		avatar : {
			display        : 'flex',
			justifyContent : 'center',
			padding        : '12px 6px 20px 0px',
			'& img'        : {
				borderRadius    : '50%',
				width           : '2rem',
				height          : '2rem',
				alignSelf       : 'center',
				objectFit       : 'cover',
				backgroundColor : '#e0e0e085'
			}
		},
		content :
		{
			margin : theme.spacing(1),
			'& p'  : {
				margin : '0'
			}
		},
		meContent :
	{
		display       : 'flex',
		flex          : 'none',
		flexDirection : 'column',
		maxWidth      : '90%',
		alignItems    : 'flex-end',
		marginTop     : '8px',
		paddingRight  : '8px',
		'& p'         : {
			margin : '0'
		}
	},
		peerContent :
	{
		display       : 'flex',
		flex          : 'none',
		flexDirection : 'column',
		maxWidth      : '90%',
		marginTop     : '8px',
		'& p'         : {
			margin : '0'
		}
	},
		isSeen : {
			backgroundColor : '#e0e0e085',
			transition      : 'background-color 1s'
		}
	});

const Message = (props) =>
{
	const intl = useIntl();

	const linkRenderer = new marked.Renderer();

	linkRenderer.link = (href, title, text) =>
	{
		title = title ? title : href;
		text = text ? text : href;

		return `<a target='_blank' href='${ href }' title='${ title }'>${ text }</a>`;
	};

	const allowedHTMLNodes = {
		ALLOWED_TAGS : [
			'a', 'b', 'strong', 'i',
			'em', 'u', 'strike', 'p',
			'br'
		],
		ALLOWED_ATTR : [ 'href', 'target', 'title' ]
	};
	const [ imageError, setImageError ] = useState(false);

	const handleImageError = () =>
	{
		setImageError(true);
	};

	const {
		avatar,
		message,
		sendTime,
		userName,
		classes,
		refMessage,
		peerId,
		sender
		// format
	} = props;

	return (
		<Paper
			className={classnames(
				classes.root,
				sender === 'Host' ? classes.sent : classes.received,
				classes.single
			)}
			data-name={userName}
			data-time={sendTime}
			ref={refMessage}
		>
			{/* <div className={classes.content}>
				<Typography variant='subtitle1'>
					<b>
						{ sender === peerId ?
							`${intl.formatMessage({
								id             : 'room.me',
								defaultMessage : 'Me'
							}) }`
							:
							<b>{userName}</b>
						} - <FormattedTime value={new Date(sendTime)} />
					</b>
				</Typography>

				<Typography
					variant='subtitle1'
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{ __html : DOMPurify.sanitize(
						marked.parse(message, { renderer: linkRenderer }),
						allowedHTMLNodes
					) }}
				/>
			</div> */}

			{sender != 'Host' &&
			<div className={classes.avatar}>
				{/* <img src={avatar} alt='Avatar' /> */}
				<img onError={(e) => { e.target.onerror = null; handleImageError(); }} src={avatar && avatar !== '' && !imageError ? `https://${import.meta.env.VITE_s3Bucket}.s3.${import.meta.env.VITE_s3Region}.amazonaws.com/public/profileImages/${avatar}` : 'images/avatar.svg'} alt='Avatar' />
			</div>
			}

			{<div className={sender === 'Host' ? classes.meContent : classes.peerContent}>
				<div className={sender === 'Host' ? 'meMsg' : 'peerMsg'} style={sender === 'Host' ? { backgroundColor: '#a9daeb', borderColor: '#a9daeb' } : { backgroundColor: '#eaecf2', borderColor: '#eaecf2' }}>
					{/* Name & Time */}
					{/* {(format === 'single' || format === 'combinedBegin') && */}
					{/* <Typography variant='subtitle1'> */}
					{
						sender === 'Host'
							? ''
						// `${intl.formatMessage({
						// 	id: 'room.me',
						// 	defaultMessage: 'Me'
						// })}`
							:
							<small>{userName}</small>
					}
					{/* </Typography> */}
					{/* } */}
					<Typography
						variant='subtitle1'
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{ __html : DOMPurify.sanitize(
							marked.parse(message.trim(), { renderer: linkRenderer }),
							allowedHTMLNodes
						) }}
						className='flagss'
					/>
				</div>
				<small className='small'>
					<FormattedTime value={new Date(sendTime)} />
				</small>
			</div>}
		</Paper>
	);
};

Message.propTypes =
{
	meetingId  : PropTypes.string,
	avatar     : PropTypes.string,
	message    : PropTypes.string,
	sendTime   : PropTypes.any,
	userName   : PropTypes.string,
	userId     : PropTypes.string,
	classes    : PropTypes.object.isRequired,
	isseen     : PropTypes.bool,
	sender     : PropTypes.string.isRequired,
	refMessage : PropTypes.object,
	width      : PropTypes.number.isRequired,
	format     : PropTypes.string.isRequired,
	peerId     : PropTypes.string.isRequired
};

export default withStyles(styles)(Message);
